'use client';

import { Suspense } from 'react';
import dynamic from 'next/dynamic';

const PaintingCanvasDynamic = dynamic(() => import('./PaintingCanvas'), { ssr: false });

export default function PaintingPreview({
  artImages,
  currentImageIndex,
  showZoomHint,
  isFullscreen,
}: {
  artImages: {
    mainSrc: string;
    alt: string;
    width: number;
    height: number;
    title: string;
    dimensions: string;
    aspectRatio: number;
    images: { main: string; normal: string; depth: string; roughness: string };
  }[];
  currentImageIndex: number;
  isFullscreen: boolean;
  showZoomHint: boolean;
}) {
  return (
    <main className="w-full h-full">
      <Suspense fallback={<div className="loading">Loading 3D Preview...</div>}>
          <PaintingCanvasDynamic
            key={currentImageIndex}
            currentImageIndex={currentImageIndex}
            artImages={artImages}
            aspectRatio={artImages[currentImageIndex].aspectRatio}
            isFullscreen={isFullscreen}
          />
        </Suspense>

        {/* Zoom instruction overlay - only shown briefly when entering fullscreen */}
        {showZoomHint && (
          <div
            style={{
              position: 'absolute',
              top: '50%',
              left: '50%',
              transform: 'translate(-50%, -50%)',
              backgroundColor: 'rgba(0, 0, 0, 0.75)',
              color: 'white',
              padding: '1rem 2rem',
              borderRadius: '0.5rem',
              textAlign: 'center',
              maxWidth: '80%',
              zIndex: 150,
              animation: 'fadeInOut 3s forwards',
            }}
          >
            <p style={{ fontSize: '1.25rem', margin: '0.5rem 0' }}>
              <strong>Enhanced Zoom Available</strong>
            </p>
            <p style={{ margin: '0.5rem 0' }}>
              Use mouse wheel or pinch gesture to zoom in for detailed texture examination
            </p>
          </div>
        )}

        {/* Add global style for the fade in/out animation */}
        <style jsx global>{`
          @keyframes fadeInOut {
            0% {
              opacity: 0;
            }
            20% {
              opacity: 1;
            }
            80% {
              opacity: 1;
            }
            100% {
              opacity: 0;
            }
          }
        `}</style>
    </main>
  );
}
